export const api = {
  gateway: {
    API_URL: "/api",
    getParams: (method) => {
      return {
        method: method || "GET",
        headers: new Headers(),
      };
    },
  },

  ///wp-json/ferrero/catalog/v1/data/es/popup
  // /media/es/images/




  media: {
    pdf: window.ferrero && (window.ferrero.locale === "es_ES" ? "/media/es/pdf/" : "/media/pt/pdf/") || "/media/es/pdf/" ,
    images: window.ferrero && (window.ferrero.locale === "es_ES" ? "/media/es/images/" : "/media/pt/images/") || "/media/es/images/",
    videos:  window.ferrero && (window.ferrero.locale === "es_ES" ? "/media/es/videos/" : "/media/pt/videos/" )|| "/media/es/videos/",

  }

  // images: {
  //   ean: "/media/producto-ean/",
  //   itf: "/media/producto-itf/",
  //   marcaLogo: "/media/marca-logo/",
  //   marcaCover: "/media/marca-cover/",
  //   categoria: "/media/categoria/",
  //   catalogo: "/media/catalogo/",
  //   popup:"/media/popup/",
  // },

};
